module.exports = __webpack_public_path__ + "static/6-25211f70b422a404fb6676152ced369a.jpeg";